import React, { useEffect, useRef, useState } from 'react'
import { getContentPath } from 'system/AssetManager'
import ControllerServerComs from 'system/ControllerServerComs'
import Globals from 'system/Globals'
import styles from './controller-narrative.module.css'
import nstyles from '../narrative/narrative.module.scss'
import { ReactComponent as Apps } from 'assets/icons/apps.svg'

const ControllerWebViewGrid = (props) => {
    const [activeIndex, setActiveIndex] = useState(null)
    const scrollContainer = useRef()

    const webviews = (props.module && props.module.webviews) || []

    // Reset local active state when the browser controller panel is closed externally
    useEffect(() => {
        if (!props.showWebviewController) {
            setActiveIndex(null)
        }
    }, [props.showWebviewController])

    function onTileClick(index) {
        props.setShowModules && props.setShowModules(false)
        setActiveIndex(index)
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-webview-grid-select-view', index)
        props.setShowWebviewController && props.setShowWebviewController(true)
    }

    function onClose() {
        setActiveIndex(null)
        props.setShowWebviewController && props.setShowWebviewController(false)
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-webview-grid-command', 'close')
    }

    const onClickBack = () => {
        props.setCurrentModule({ typeName: 'controller-narrative' })
        props.setAnimInCurrentModule(false)
        ControllerServerComs.instance().sendUDPFromControllerToServer('narrative-close-module')
    }

    return (
        <React.Fragment>
            <div className={`${styles.linksContainer} ${styles.moduleLinksContainer} hide-scroller ${nstyles.galleryLinksContainer}`}>

                {!props.showModules && (
                    <span className={styles.switchMenu} onClick={() => props.setShowModules(s => !s)}>
                        <span className={nstyles.switchMenuBtn}><Apps /></span>
                        <h4>{props.module.title}</h4>
                    </span>
                )}

                <div className={`${styles.controllerLinks} hide-scroller`}>
                    {!props.showModules && webviews.map((item, i) => (
                        <span
                            key={`wvg-link-${i}`}
                            className={styles.controllerMenuLinkRow}
                            onClick={() => onTileClick(i)}
                        >
                            <div
                                className={`${nstyles.menuLink} ${styles.controllerMenuLink}`}
                                style={activeIndex === i
                                    ? Globals.instance().getThemeStyle(['nav-menu-item-selected'], props.theme)
                                    : Globals.instance().getThemeStyle(['nav-menu-item'], props.theme)
                                }
                            >
                                {item.title || item.caption || item.webview_url}
                            </div>
                        </span>
                    ))}
                </div>

            </div>

            <section ref={scrollContainer} className={styles.moduleHolder}>

                {props.showBackBtn && activeIndex === null && (
                    <div className={styles.backBtnRow}>
                        <div className={styles.pillBtn} onClick={onClickBack}>Back to Presentation</div>
                    </div>
                )}

                <div className={`${styles.galleryThumbnails} ${props.showBackBtn ? styles.hasBackBtnRow : ''}`}>
                    {webviews.map((item, i) => (
                        <div
                            key={`wvg-thumb-${i}`}
                            className={`${styles.galleryThumbnail} ${activeIndex === i ? 'linkOn' : ''}`}
                            onClick={() => onTileClick(i)}
                        >
                            {item.image
                                ? <img src={getContentPath(item.image, true)} alt="" />
                                : <div style={{ width: '100%', aspectRatio: '16/9', background: '#444', borderRadius: '4px' }} />
                            }
                            {item.title && (
                                <div className={styles.caption}>{item.title}</div>
                            )}
                        </div>
                    ))}
                </div>

            </section>
        </React.Fragment>
    )
}

export default ControllerWebViewGrid
